/**
 * Date copy for Explore cards. Every input is an optional ISO-8601 string from
 * aris-ai; an absent or unparseable value returns "" so the caller can omit the
 * line rather than print "Invalid Date".
 */

const parse = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** "Sep 14" — the Active rail's "Last conversation" date. */
export const shortDate = (iso) => {
  const d = parse(iso);
  if (!d) return "";
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
};

/**
 * "Today", "Yesterday", "3 days ago", "1 week ago", "2 months ago" — the
 * Personal Dialogue Library subtitle (Figma 9154:8266).
 */
export const relativeDay = (iso, now = new Date()) => {
  const d = parse(iso);
  if (!d) return "";
  const startOf = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate());
  const days = Math.round((startOf(now) - startOf(d)) / 86400000);
  if (days <= 0) return "Today";
  if (days === 1) return "Yesterday";
  if (days < 7) return `${days} days ago`;
  if (days < 30) {
    const weeks = Math.floor(days / 7);
    return `${weeks} ${weeks === 1 ? "week" : "weeks"} ago`;
  }
  if (days < 365) {
    const months = Math.floor(days / 30);
    return `${months} ${months === 1 ? "month" : "months"} ago`;
  }
  const years = Math.floor(days / 365);
  return `${years} ${years === 1 ? "year" : "years"} ago`;
};

/** "Aug 26, 2026" — the Active Dialogues list's Paused / Completed / Archived date. */
export const longDate = (iso) => {
  const d = parse(iso);
  if (!d) return "";
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};
